import { render, staticRenderFns } from "./points-details.vue?vue&type=template&id=8e9e04bc&scoped=true"
import script from "./points-details.vue?vue&type=script&lang=js"
export * from "./points-details.vue?vue&type=script&lang=js"
import style0 from "./points-details.vue?vue&type=style&index=0&id=8e9e04bc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9e04bc",
  null
  
)

export default component.exports